import amplitude from 'amplitude-js'

export const initAmplitude = () => {
  amplitude.getInstance().init("c5b4fc0363c17ac9d1dcbea4707c6e4a");
};

export const sendAmplitudeData = (eventType, eventProperties) => {
  amplitude.getInstance().logEvent(eventType, eventProperties);
};